const OneClassSvmKernel = {
	LINEAR: 'Linear',
	POLY: 'Poly',
	RBF: 'Rbf',
	SIGMOID: 'Sigmoid'
};

export default OneClassSvmKernel;
